import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: "AIzaSyDPdnquPVzkXLmJ8C33CFfLecyQa48D30E",
  authDomain: "dklbooks-9686d.firebaseapp.com",
  projectId: "dklbooks-9686d",
  storageBucket: "dklbooks-9686d.firebasestorage.app",
  messagingSenderId: "419068324496",
  appId: "1:419068324496:web:0caf9d5ba11b1e3374c615"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions();